import {LayoutModalSessionExpired} from '#components';

export function useSessionExpiredModal() {
  return new Promise(resolve => {
    const modal = useFModal({
      id: 'session-expired',
      size: 'sm',
      showClose: false,
      clickToClose: false,
      escToClose: false,
      backdropClass: BACKDROP_BLUR_CLASS,
      component: LayoutModalSessionExpired,
      eventHandlers: {
        confirm() {
          modal.close();
          resolve();
        }
      }
    });
    modal.open();
  });
}
